import {Chip, Drawer, IconButton, Box, Dialog} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledAddressDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    width: '100%'
  }
}));

export const StyledSectionWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  '&.multiple': {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2)
    }
  }
}));

export const StyledSectionContentContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledPointsChip = styled(Chip)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(1),
  borderColor: theme.palette.grey[300],
  fontSize: theme.typography.button.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.caption.fontSize
  }
}));

export const StyledAddressDrawerHeader = styled(Box)(({theme}) => ({
  width: '-webkit-fill-available',
  padding: theme.spacing(2, 3),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const StyleAddressDrawerHeaderWrapper = styled(Box)(() => ({
  width: '100%',
  display: 'block'
}));

export const StyleAddressDrawerHeaderContainer = styled(Box)<{isReactNativeView?: boolean}>(
  ({theme, isReactNativeView}) => ({
    width: '-webkit-fill-available',
    padding: isReactNativeView ? theme.spacing(2) : theme.spacing(0),
    display: 'block'
  })
);

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  padding: 0,
  marginRight: theme.spacing(1.25)
}));

export const StyledDialog = styled(Dialog)(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    width: '360px',
    height: 'auto',
    padding: theme.spacing(2, 2, 3, 2)
  },
  '& .MuiDialogTitle-root': {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 0
  },
  '& .MuiDialogContent-root': {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  '& .MuiDialogActions-root': {
    display: 'flex',
    justifyContent: 'center'
  }
}));

export const StyledBottomSheet = styled(Drawer)(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px 12px 0px 0px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    height: 'auto',
    padding: theme.spacing(2, 2, 3, 2)
  },
  '& .MuiDialogTitle-root': {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 0
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'center'
  }
}));
